import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@STORE/index';

import { 
    documentIntroductionTextModalSlice, 
    DocumentIntroductionTextModalDispatchParams, 
    DocumentIntroductionTextModalState,
} from '@REDUCERS';

function createDocumentIntroductionTextModalHook() {
    return function useDocumentIntroductionTextModal(equalityFn?: EqualityFn<DocumentIntroductionTextModalState>) {
        const state = useAppSelector((store) => store.documentIntroductionTextModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: DocumentIntroductionTextModalDispatchParams) => dispatch(documentIntroductionTextModalSlice.actions.open(params)),
            close: () => dispatch(documentIntroductionTextModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createDocumentIntroductionTextModalHook(); 